(function () {
  function push(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function eventId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }

  function handleFromUrl(url) {
    const match = String(url || "").match(/\/products\/([a-z0-9-_]+)/i);
    return match ? match[1] : "";
  }

  function sourceFor(button) {
    if (!button) return "post_login";
    if (button.closest(".card-product__button--notify")) return "product_card";
    if (button.closest(".button-notify")) return "home_hero";
    if (button.closest(".quick-add")) return "plp_popup";
    return "pdp";
  }

  // Capture phase so tracking fires before the CTA handlers, which may stop
  // propagation (quick-add popup open, notify subscribe).
  document.addEventListener(
    "click",
    function (event) {
      // Waitlist CTA on product cards (PLP grid, home carousels)
      const cardCta = event.target.closest(".card-product__button--notify");
      if (cardCta) {
        if (cardCta.classList.contains("disabled")) return;

        push({
          event: "notify_me_click",
          notify_source: "product_card",
          product_handle: handleFromUrl(cardCta.dataset.productUrl),
          page_path: window.location.pathname,
        });
        return;
      }

      // notify-me buttons: PDP, quick view popup, home hero block
      const notifyButton = event.target.closest(
        "notify-me [data-notify-button]",
      );
      if (!notifyButton || notifyButton.disabled) return;

      const element = notifyButton.closest("notify-me");

      push({
        event: "notify_me_click",
        notify_source: sourceFor(notifyButton),
        product_handle: (element && element.dataset.productHandle) || "",
        page_path: window.location.pathname,
      });
    },
    true,
  );

  document.addEventListener("notify-me:subscribed", function (event) {
    const detail = event.detail || {};
    const button = detail.button || null;

    push({
      event: "notify_me_success",
      notify_source: sourceFor(button),
      product_handle: detail.productHandle || "",
      page_path: window.location.pathname,
      "gtm.element": button,
      "gtm.elementClasses": button ? button.className : "",
      "gtm.elementId": button ? button.id : "",
      "gtm.elementText": detail.label || "",
    });

    push({
      event: "waitlist_joined",
      event_id: eventId(),
    });
  });
})();
